import styled from '@emotion/styled';
import { withConfig } from 'src/withConfig';

export const PriceHistoryList = withConfig(theme => styled('span', { label: 'PriceHistoryList' })`
    font-size: ${theme.star.fontSize.xSmall};
    line-height: ${theme.star.lineHeight[150]};
`);
